export const generatePassword = (
  letters: number,
  numbers: number,
  special: number
) => {
  const chars = [
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", // letters
    "0123456789", // numbers
    "!@#£$§%&?+*-" // special characters
  ];

  return [letters, numbers, special]
    .map(function (len, i) {
      return Array(len)
        .fill(chars[i])
        .map(function (x) {
          return x[Math.floor(Math.random() * x.length)];
        })
        .join("");
    })
    .concat()
    .join("")
    .split("")
    .sort(function () {
      return 0.5 - Math.random();
    })
    .join("");
};
